// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toast-stack {
  position: fixed;
  z-index: 3000;
  top: 16px;
  right: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: min(380px, calc(100vw - 32px));
  pointer-events: none;
}

.toast {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 13px 14px;
  border-radius: var(--radius);
  background: var(--surface);
  border: 1px solid var(--border);
  border-left: 4px solid var(--brand);
  box-shadow: var(--shadow);
  pointer-events: auto;
  animation: toast-in 0.25s ease;
}

.toast-success {
  border-left-color: #16a34a;
}

.toast-error {
  border-left-color: var(--danger);
}

.toast-icon {
  flex-shrink: 0;
  margin-top: 2px;
  color: var(--brand);
}

.toast-success .toast-icon {
  color: #16a34a;
}

.toast-error .toast-icon {
  color: var(--danger);
}

.toast-msg {
  flex: 1 1;
  font-size: 0.9rem;
  line-height: 1.5;
  color: var(--text-soft);
}

.toast-close {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--muted2);
  cursor: pointer;
}

.toast-close:hover {
  background: var(--bg);
  color: var(--text);
}

@keyframes toast-in {
  from {
    opacity: 0;
    transform: translateX(16px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@media (max-width: 560px) {
  .toast-stack {
    top: auto;
    bottom: 16px;
    left: 16px;
    right: 16px;
    max-width: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .toast {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/contexts/Toast.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,SAAS;EACT,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,0BAA0B;EAC1B,+BAA+B;EAC/B,mCAAmC;EACnC,yBAAyB;EACzB,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,SAAS;IACT,YAAY;IACZ,UAAU;IACV,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".toast-stack {\n  position: fixed;\n  z-index: 3000;\n  top: 16px;\n  right: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  max-width: min(380px, calc(100vw - 32px));\n  pointer-events: none;\n}\n\n.toast {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 13px 14px;\n  border-radius: var(--radius);\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-left: 4px solid var(--brand);\n  box-shadow: var(--shadow);\n  pointer-events: auto;\n  animation: toast-in 0.25s ease;\n}\n\n.toast-success {\n  border-left-color: #16a34a;\n}\n\n.toast-error {\n  border-left-color: var(--danger);\n}\n\n.toast-icon {\n  flex-shrink: 0;\n  margin-top: 2px;\n  color: var(--brand);\n}\n\n.toast-success .toast-icon {\n  color: #16a34a;\n}\n\n.toast-error .toast-icon {\n  color: var(--danger);\n}\n\n.toast-msg {\n  flex: 1;\n  font-size: 0.9rem;\n  line-height: 1.5;\n  color: var(--text-soft);\n}\n\n.toast-close {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: var(--muted2);\n  cursor: pointer;\n}\n\n.toast-close:hover {\n  background: var(--bg);\n  color: var(--text);\n}\n\n@keyframes toast-in {\n  from {\n    opacity: 0;\n    transform: translateX(16px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@media (max-width: 560px) {\n  .toast-stack {\n    top: auto;\n    bottom: 16px;\n    left: 16px;\n    right: 16px;\n    max-width: none;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .toast {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
